var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "100px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "门店地址：" } },
                    [
                      _c("el-cascader", {
                        staticClass: "search-w",
                        attrs: {
                          clearable: "",
                          options: _vm.addresData,
                          props: {
                            value: "id",
                            label: "name",
                            children: "child",
                            expandTrigger: "hover",
                            checkStrictly: true,
                          },
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.addressId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "addressId", $$v)
                          },
                          expression: "listPram.addressId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品品牌" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "search-w",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _vm.handleAgreementSearch,
                          },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.brandId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "brandId", $$v)
                            },
                            expression: "listPram.brandId",
                          },
                        },
                        _vm._l(_vm.brandOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.brandStr, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "门店名称：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "search-w",
                          attrs: {
                            placeholder: "门店名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.storeName,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "storeName", $$v)
                            },
                            expression: "listPram.storeName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "门店电话：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "search-w",
                          attrs: {
                            placeholder: "门店电话",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.storePhone,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "storePhone", $$v)
                            },
                            expression: "listPram.storePhone",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerOpenEdit({})
                    },
                  },
                },
                [_vm._v("添加门店")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "id", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": true,
                  prop: "brandName",
                  label: "品牌名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": true,
                  prop: "cityName",
                  label: "城市名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": true,
                  prop: "storeName",
                  label: "门店名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storePhone",
                  label: "门店电话",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeLng",
                  label: "门店经度",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeLat",
                  label: "门店纬度",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeAddr",
                  label: "门店地址",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "门店形象", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._getstorePic(scope.row.storePic)
                          ? _c(
                              "div",
                              { staticClass: "demo-image__preview" },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "36px",
                                    height: "36px",
                                  },
                                  attrs: {
                                    src: _vm._getstorePic(scope.row.storePic),
                                    "preview-src-list": [
                                      _vm._getstorePic(scope.row.storePic),
                                    ],
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "source", label: "来源", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "200",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerGoodsChannel(scope.row)
                              },
                            },
                          },
                          [_vm._v("商品列表")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditStorechannel", {
        ref: "EditStorechannelRef",
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("ShopGoods", {
        ref: "ShopGoodsRef",
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("BindChannel", {
        ref: "BindChannelRef",
        on: { doRefresh: _vm.handerSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }